import * as React from 'react'

const BookkeeperViewContext = React.createContext<boolean>(false)

interface BookkeeperViewProviderProps {
  isBookkeeperView: boolean
}

export const BookkeeperViewProvider = ({
  isBookkeeperView,
  children,
}: React.PropsWithChildren<BookkeeperViewProviderProps>) => (
  <BookkeeperViewContext.Provider value={isBookkeeperView}>
    {children}
  </BookkeeperViewContext.Provider>
)

export const useBookkeeperView = (): boolean => {
  const isBookkeeperView = React.useContext(BookkeeperViewContext)

  return isBookkeeperView ?? false
}
